import TransformComponent from '../../../Component/Transform';
import Renderable from '../../../Component/Renderable';
import GameObject from '../../../GameObject/GameObject';
import Sprite from '../../Sprite';
import Point from '../../../Utility/Point';
import LevelNodeState from './LevelNodeState';
import { LevelNodeType } from './LevelNodeType';

export default class LevelNodeIndicator extends GameObject {
    public unlockState: LevelNodeState;

    private backgroundCacheKey: string;
    private symbolCacheKey: string;
    private symbolScale: Point;

    public onCreate(params: {
        x: number;
        y: number;
        type: LevelNodeType;
        unlockState: LevelNodeState;
        fieldId?: string;
    }): void {
        this.name = 'indicator';
        this.addComponent(TransformComponent, params);
        this.addComponent(Renderable, {
            ...params,
        });
        this.unlockState = params.unlockState;

        this.backgroundCacheKey =
            this.unlockState === LevelNodeState.CURRENT
                ? 'crop_unlocked_base_current'
                : 'crop_unlocked_base';

        switch (params.type) {
            case LevelNodeType.CROP_UNLOCK:
                if (!params.fieldId) {
                    this.show(false);
                    break;
                }
                this.symbolScale = new Point(0.55, 0.55);
                this.symbolCacheKey = `${params.fieldId.toLowerCase()}_harvest_map`;
                break;
            case LevelNodeType.FIELD_UNLOCK:
                this.symbolScale = new Point(0.92, 0.92);
                this.symbolCacheKey = 'clock_icon_node';
                break;
            case LevelNodeType.FREE_SPIN:
                this.symbolScale = new Point(0.92, 0.92);
                this.symbolCacheKey = 'spin_icon_node';
                break;
            default:
                this.show(false);
                console.warn(
                    `Level node of type '${params.type}' was not handeled.`
                );
                break;
        }
        const background: GameObject = GameObject.Instantiate(Sprite, {
            name: 'background',
            texture: this.backgroundCacheKey,
            position: new Point(0, 15),
            anchor: new Point(0.5, 0),
            scale: new Point(1, 1),
        });

        const symbol: Sprite = GameObject.Instantiate(Sprite, {
            name: 'symbol',
            texture: this.symbolCacheKey || 'blank',
            position: new Point(0, 43),
            anchor: new Point(0.5, 0.5),
            scale: this.symbolScale || Point.One,
        });
        background.addChild(symbol);
        this.addChild(background);

        if (this.unlockState === LevelNodeState.COMPLETE) {
            this.show(false);
        }
    }

    public show(value: boolean = true): void {
        this.getComponent<Renderable>(Renderable).visible = value;
    }
}
